// extracted by mini-css-extract-plugin
export default {"usufruit-warning":"classes_usufruit-warning__Y3HXV","with-contrepartie-warning":"classes_with-contrepartie-warning__z-MtH"};